/* LT Racing, global.js  (vanilla, dependency-free, mobile-first) */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -------- Mobile nav drawer -------- */
  function initDrawer() {
    var toggles = document.querySelectorAll('[data-drawer-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-drawer-toggle');
        var drawer = document.getElementById(id);
        if (!drawer) return;
        var open = drawer.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('no-scroll', open);
        if (open) {
          var first = drawer.querySelector('a,button');
          if (first) first.focus();
        }
      });
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var drawer = btn.closest('.nav-drawer');
        if (!drawer) return;
        drawer.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
        var t = document.querySelector('[data-drawer-toggle="' + drawer.id + '"]');
        if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.nav-drawer.is-open');
      if (open) {
        open.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
        var t = document.querySelector('[data-drawer-toggle="' + open.id + '"]');
        if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
      }
    });
  }

  /* -------- Sticky header shadow on scroll -------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -------- Hero carousel -------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
      if (!track || slides.length < 1) return;
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var interval = parseInt(root.getAttribute('data-carousel-interval'), 10) || 6000;
      var autoplay = root.getAttribute('data-carousel-autoplay') === 'true' && !reduceMotion && slides.length > 1;
      var index = 0, timer = null;

      function go(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
          s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
        });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === index);
          d.setAttribute('aria-selected', n === index ? 'true' : 'false');
        });
      }
      function nextSlide() { go(index + 1); }
      function start() { if (autoplay) { stop(); timer = setInterval(nextSlide, interval); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (next) next.addEventListener('click', function () { go(index + 1); start(); });
      if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      /* swipe */
      var x0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
        x0 = null; start();
      }, { passive: true });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      go(0); start();
    });
  }

  /* -------- Product-row scroll arrows -------- */
  function initRows() {
    document.querySelectorAll('[data-row]').forEach(function (root) {
      var scroller = root.querySelector('[data-row-scroll]');
      if (!scroller) return;
      var prev = root.querySelector('[data-row-prev]');
      var next = root.querySelector('[data-row-next]');
      function amount() {
        var card = scroller.querySelector('.card');
        return card ? card.getBoundingClientRect().width + 14 : scroller.clientWidth * 0.8;
      }
      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth - 2;
        if (prev) prev.disabled = scroller.scrollLeft <= 2;
        if (next) next.disabled = scroller.scrollLeft >= max;
      }
      if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: amount(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* -------- Sticky mobile add-to-cart reveal -------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -20% 0px' });
    io.observe(anchor);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initDrawer();
    initStickyHeader();
    initCarousels();
    initRows();
    initStickyAtc();
  });
})();


/* LT cinematic reveal + hero parallax (added) */
(function(){
  try{
    if(!('IntersectionObserver' in window))return;
    var mq=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
    if(mq&&mq.matches)return;
    document.documentElement.classList.add('has-reveal');
    var sel='.herof__copy,.herof__media,.section-head,.sbb__card,.card,.fb__tile,.reviews-bar__inner,.brand-story__grid,.trust__item,.pdp__gallery,.pdp__info,.plp__head,.story-prose__col,.pdp-rev';
    var els=[].slice.call(document.querySelectorAll(sel));
    els.forEach(function(el){el.classList.add('reveal');});
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -7% 0px',threshold:0.08});
    els.forEach(function(el){io.observe(el);});
    var h=document.querySelector('.herof__media img');
    if(h){window.addEventListener('scroll',function(){var y=window.pageYOffset||0;if(y<900)h.style.transform='translateY('+(y*0.05).toFixed(1)+'px)';},{passive:true});}
  }catch(e){}
})();
